// extracted by mini-css-extract-plugin
module.exports = {"container":"Favorites_container__3Htcr","favoriteList":"Favorites_favoriteList__2i7fW"};